import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  fundedInvoicesData,
  email,
  auPhNumber,
  nzPhNumber
} from "../../locales/en";
import Style from "./modal.module.scss";
import CommonModal from "./CommonModal";
import { MAILTO_INFO_EMAIL } from "../../utils/constants/appConstants";

const SyncInvoiceModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      size="md"
      modalClassName={`${Style.xeroModal} modal-dialog-centered`}
      headerClassName={Style.creditModalHeader}
      title={fundedInvoicesData?.SyncInvoiceModal?.title}
      hideFooter
    >
      <div className={`${Style.manualUploadContent} modal-content  border-0`}>
        <div className="SyncInvoiceModal d-flex flex-column">
          <p>
            <strong className="me-1">
              {fundedInvoicesData?.SyncInvoiceModal?.text1}
            </strong>
            {fundedInvoicesData?.SyncInvoiceModal?.text2}
          </p>
          <p>
            <strong className="me-1">
              {fundedInvoicesData?.SyncInvoiceModal?.text3}
            </strong>
            {fundedInvoicesData?.SyncInvoiceModal?.text4}
          </p>
          <p>
            <strong className="me-1">
              {fundedInvoicesData?.SyncInvoiceModal?.text5}
            </strong>
            {fundedInvoicesData?.SyncInvoiceModal?.text6}
          </p>
          <p>
            <strong className="me-1">
              {fundedInvoicesData?.SyncInvoiceModal?.text7}
            </strong>
            {fundedInvoicesData?.toFund?.content14}
            <Link className="ms-1 me-1" to={MAILTO_INFO_EMAIL}>
              {email}
            </Link>
            {fundedInvoicesData?.toFund?.content15}
            <Link className="ms-1 me-1" to={`tel:${auPhNumber}`}>
              {auPhNumber}
            </Link>
            {fundedInvoicesData?.toFund?.content16}
            <Link className="ms-1" to={`tel:${nzPhNumber}`}>
              {nzPhNumber}
            </Link>
          </p>
        </div>
      </div>
    </CommonModal>
  );
};

SyncInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default SyncInvoiceModal;
